import axios from 'axios'
import { Toast } from 'vant'
const baseUrl = 'https://gec-api.gecacademy.cn/souapi'
// const baseUrl = 'https://gec-api-testserver.gecacademy.cn/souapi'
// const baseUrl = 'http://192.168.1.72:10066/'
const service = axios.create({ baseURL: baseUrl, timeout: 10000, withCredentials: true })
service.interceptors.request.use(
  config => { return config },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    Toast({ message: error.message, type: 'fail', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service
